module.exports = __webpack_public_path__ + "static/media/owl-success-proposal.086f4e88.svg";